import { atom } from 'jotai'
import { atomWithStorage } from 'jotai/utils'
import { loadable } from 'jotai/utils'
import { login } from '@/services/authentication/login'
import type { LoginRequest, LoginResponse } from '@/types/authentication'

// WO captured from the encrypted email link — always takes priority over the login response WO
export const emailLinkWorkOrderIdAtom = atomWithStorage<number | null>(
  'emailLinkWorkOrderId',
  null,
  undefined,
  { getOnInit: true },
)

//TODO flush the request once signed in, no need to keep password in state
export const loginRequestAtom = atom<LoginRequest | null>(null)

// Persisted across tabs/sessions
export const loggedInEmailAtom = atomWithStorage<string | null>(
  'loggedInEmail',
  null,
)

export const fetchLoginAtom = atom<Promise<LoginResponse | null>>(
  async (get) => {
    const loginRequest = get(loginRequestAtom)

    if (!loginRequest?.emailAddress || !loginRequest?.password) {
      return null
    }

    return await login(loginRequest)
  },
)

const _initialWorkOrderIdBaseAtom = atomWithStorage<number | null>(
  'initialWorkOrderId',
  null,
  undefined,
  { getOnInit: true },
)

export const initialWorkOrderIdAtom = atom<
  number | null,
  [number | null],
  void
>(
  (get) => {
    const existing = get(_initialWorkOrderIdBaseAtom)
    if (existing !== null) return existing

    const loginResult = get(loadableLoginAtom)

    if (
      loginResult.state === 'hasData' &&
      loginResult.data?.data?.workOrderId != null
    ) {
      //return 1977274
      return loginResult.data.data.workOrderId
    }

    return null
  },
  (get, set, newValue) => {
    const current = get(_initialWorkOrderIdBaseAtom)

    // Allow reset to null
    if (newValue === null) {
      set(_initialWorkOrderIdBaseAtom, null)
      return
    }

    // Prevent overwriting once set
    if (current !== null) return

    set(_initialWorkOrderIdBaseAtom, newValue)
  },
)

export const loadableLoginAtom = loadable(fetchLoginAtom)
